module.exports = require("immutable");


//////////////////
// WEBPACK FOOTER
// external "immutable"
// module id = 8
// module chunks = 0